// Resolve a CSS custom property to its computed value, with a fallback.
// Read from <body>, not <html>: the dark --sl-* overrides are scoped to
// `body.od-themed`, so resolving against documentElement returns light values.
export const resolveToken = (name, fallback) => {
  if (typeof document === 'undefined' || typeof window === 'undefined' || !document.body) return fallback;
  const value = getComputedStyle(document.body).getPropertyValue(name).trim();
  return value || fallback;
};
